import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAllHardwareTypes } from '../../../api/hardware';

const useHardwareTypes = (options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>) => {
  return useQuery({
    queryKey: ['hardwareTypes'],
    queryFn: getAllHardwareTypes,
    ...options,
  });
};

export default useHardwareTypes;
